<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      nestKey: {
        type: String,
        default: ''
      },
      currentData: {
        type: Object,
        default: null
      }
    },
    emits: ['form-data'],
    computed: {
      reverse () {
        return this.$i18n.locale !== 'ja'
      },
      ...mapGetters(['login', 'ui'])
    },
    watch: {
      // formData変更を親コンポーネントへ渡す
      formData: {
        handler: function () {
          this.$emit('form-data', this.formData)
        },
        deep: true
      },
      currentData: {
        handler: function () {
          this.applyCurrentData()
        },
        deep: true
      }
    },
    methods: {
      reset () {
        // data初期化
        Object.assign(this.$data.formData, this.$options.data().formData)
      },
      applyCurrentData () {
        if (this.currentData) {
          const obj = this.currentData
          for (let key of Object.keys(obj)) { this.formData[key] = obj[key] }
        }
      },
      fieldKey (fieldKey) {
        if (this.nestKey) {
          return `${this.nestKey}.${fieldKey}`
        } else {
          return fieldKey
        }
      }
    }
  }
</script>
